import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Icon from '~/core/scripts/components/Icon';

import './Legend.styl';

const Legend = memo((props) =>  {
  if (!props.isVisible) {
    return null;
  }

  return (
    <div className="legend">
      {props.icon && (
        <div className="legend__icon">
          <Icon type={props.icon} />
        </div>
      )}
      <div
        className="legend__label start"
        dangerouslySetInnerHTML={{ __html: props.minLabel}}
      />
      <div className="legend__items">
        {props.colors.map(c => (
          <div
            key={`legend_item-${c.key || c}`}
            className="legend__item"
            style={{ backgroundColor: c.key || c }}
          />
        ))}
      </div>
      <div
        className="legend__label end"
        dangerouslySetInnerHTML={{ __html: props.maxLabel}}
      />
    </div>
  );
});

Legend.displayName = 'Legend';

Legend.propTypes = {
  isVisible: PropTypes.bool,
  minLabel: PropTypes.string,
  maxLabel: PropTypes.string,
  colors: PropTypes.array
};

Legend.defaultProps = {
  isVisible: true
};

export default Legend;
